
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    theme: {
      type: String,
      default: 'white'
    }
  }
})
